(function () {
  if (window.__oskinaProductLoaded) return;
  window.__oskinaProductLoaded = true;

  var BUNDLE_SELECTOR = '[data-oskina-bundle]';
  var CARD_SELECTOR = '[data-bundle-qty]';
  var SWATCH_SELECTOR = '[data-bundle-swatch]';
  var ADD_TO_CART_SELECTOR =
    'product-form-component button[type="submit"][name="add"], .sticky-add-to-cart__button, .add-to-cart-button';

  function getBundleRoot() {
    return document.querySelector(BUNDLE_SELECTOR);
  }

  function getForm() {
    return document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function getQtyInput(form) {
    if (!form) return null;
    var input = form.querySelector('input[name="quantity"]');
    if (input) return input;
    return form.querySelector('quantity-input-component input, .quantity__input');
  }

  function getVariantPicker() {
    return document.querySelector('variant-picker, .variant-picker');
  }

  function setQuantity(form, value) {
    var qtyInput = getQtyInput(form);
    if (!qtyInput) return;
    qtyInput.value = value;
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function hideQuantitySelector(form) {
    if (!form) return;
    var qtyWrap = form.querySelector(
      '.quantity-selector-wrapper, quantity-input-component, .quantity-selector, [class*="quantity-selector"]'
    );
    if (qtyWrap) qtyWrap.style.display = 'none';
  }

  function toggleVariantPicker(show) {
    var picker = getVariantPicker();
    if (!picker) return;
    picker.style.display = show ? '' : 'none';
  }

  function setFormVariant(form, variantId) {
    if (!form || !variantId) return;
    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;
    variantInput.value = String(variantId);
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    variantInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function getSwatchScope(swatch) {
    return swatch.closest('[data-bundle-line]') || swatch.closest('.oskina-pdp-bundle__swatches');
  }

  function getCardSelectedVariantId(card) {
    var active = card.querySelector('[data-variant-selected="true"]');
    if (active) return Number(active.getAttribute('data-variant-id'));

    var form = getForm();
    if (!form) return null;
    var variantInput = form.querySelector('input[name="id"]');
    return variantInput && variantInput.value ? Number(variantInput.value) : null;
  }

  function getSelectedCard(bundle) {
    return bundle.querySelector('[data-bundle-selected="true"]');
  }

  function selectCard(bundle, card) {
    bundle.querySelectorAll(CARD_SELECTOR).forEach(function (c) {
      var selected = c === card;
      c.classList.toggle('is-selected', selected);
      c.setAttribute('aria-pressed', selected ? 'true' : 'false');
      c.setAttribute('data-bundle-selected', selected ? 'true' : 'false');
    });

    var form = getForm();
    var mode = card.getAttribute('data-bundle-mode');
    var qty = card.getAttribute('data-bundle-qty');

    if (form) setQuantity(form, qty);
    toggleVariantPicker(false);

    if (mode === 'single') {
      var variantId = getCardSelectedVariantId(card);
      if (variantId) setFormVariant(form, variantId);
    }
  }

  function handleSwatchClick(swatch, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }

    var bundle = swatch.closest(BUNDLE_SELECTOR);
    if (!bundle) return;

    var scope = getSwatchScope(swatch);
    if (!scope) return;

    scope.querySelectorAll(SWATCH_SELECTOR).forEach(function (btn) {
      var active = btn === swatch;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('data-variant-selected', active ? 'true' : 'false');
    });

    var card = swatch.closest(CARD_SELECTOR);
    if (!card) return;

    var mode = card.getAttribute('data-bundle-mode');
    if (mode === 'single') {
      setFormVariant(getForm(), Number(swatch.getAttribute('data-variant-id')));
    }

    if (card.getAttribute('data-bundle-selected') !== 'true') {
      selectCard(bundle, card);
    }
  }

  function handleCardActivate(card, event) {
    if (event && event.target.closest(SWATCH_SELECTOR)) return;

    var bundle = card.closest(BUNDLE_SELECTOR);
    if (!bundle) return;
    selectCard(bundle, card);
  }

  function getMultiVariantItems(card) {
    var items = [];
    card.querySelectorAll('[data-bundle-line]').forEach(function (row) {
      var active = row.querySelector('[data-variant-selected="true"]');
      if (!active) return;
      items.push({
        id: Number(active.getAttribute('data-variant-id')),
        quantity: 1,
      });
    });
    return items;
  }

  function getBundleMeta(selected) {
    var mode = selected.getAttribute('data-bundle-mode');
    var qty = Number(selected.getAttribute('data-bundle-qty')) || 1;
    if (mode === 'single') {
      return { key: '1x', qty: 1, offer: '', compare: 0, price: 0 };
    }
    var lang = (document.documentElement.getAttribute('lang') || '').slice(0, 2).toLowerCase();
    var de = lang === 'de';
    if (qty >= 5) {
      return { key: '3plus2', qty: 5, offer: de ? '3+2 GRATIS' : '3+2 OFFERTS', compare: 9995, price: 4499 };
    }
    return { key: '2plus1', qty: 3, offer: de ? '2+1 GRATIS' : '2+1 OFFERT', compare: 5997, price: 3499 };
  }

  function mergeSameVariantItems(items) {
    if (!items.length) return items;
    var firstId = items[0].id;
    var same = items.every(function (item) {
      return item.id === firstId;
    });
    if (!same) return items;
    var quantity = items.reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
    return [{ id: firstId, quantity: quantity }];
  }

  function attachBundleProperties(items, meta) {
    var bundleId = 'oskina-' + meta.key + '-' + Date.now();
    return items.map(function (item) {
      var properties = {
        _oskina_bundle: meta.key,
        _oskina_bundle_id: bundleId,
        _oskina_bundle_qty: String(meta.qty),
      };
      if (meta.compare) properties._oskina_compare = String(meta.compare);
      if (meta.price) properties._oskina_bundle_price = String(meta.price);
      if (meta.offer) properties._oskina_offer = meta.offer;
      return {
        id: item.id,
        quantity: item.quantity,
        properties: properties,
      };
    });
  }

  function getAddToCartButton() {
    return document.querySelector(ADD_TO_CART_SELECTOR);
  }

  function animateAddToCartSuccess() {
    var button = getAddToCartButton();
    if (!button) return;

    button.dataset.added = 'true';
    button.blur();

    window.setTimeout(function () {
      button.removeAttribute('data-added');
    }, 800);
  }

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    try {
      if (typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
    } catch (err) {
      console.warn('[oskina-product] drawer.open', err);
    }
    var panel = drawer.querySelector('dialog');
    if (!panel || panel.open) return;
    try {
      if (window.matchMedia('(max-width: 989px)').matches && typeof panel.showModal === 'function') {
        panel.showModal();
      } else if (typeof panel.show === 'function') {
        panel.show();
      }
      drawer.setAttribute('open', '');
    } catch (err) {
      console.warn('[oskina-product] dialog.show', err);
    }
  }

  function dispatchCartUpdate(sections) {
    var drawerApi = window.OskinaCart;
    var applied = drawerApi && drawerApi.applyFromSections && drawerApi.applyFromSections(sections);
    openCartDrawer();
    if (applied || !drawerApi || typeof drawerApi.sync !== 'function') {
      return Promise.resolve();
    }
    return drawerApi.sync().then(function () {
      openCartDrawer();
    });
  }

  var addInProgress = false;

  function cartJsonUrl() {
    return window.Theme && Theme.routes && Theme.routes.cart_url ? Theme.routes.cart_url : '/cart';
  }

  function cartUpdateUrl() {
    return window.Theme && Theme.routes && Theme.routes.cart_update_url
      ? Theme.routes.cart_update_url
      : '/cart/update.js';
  }

  function isTowelCartItem(item) {
    var props = item.properties || {};
    if (props._oskina_bundle) return true;
    var root = getBundleRoot();
    var productId = root && root.getAttribute('data-product-id');
    if (productId && String(item.product_id) === String(productId)) return true;
    return item.handle === 'serviette-de-douche-exfoliante-oskina';
  }

  function cartLooksEmpty() {
    if (
      document.querySelector(
        '#cart-drawer .cart-drawer--empty, #cart-drawer [data-cart-drawer-empty], #cart-drawer .oskina-cart-empty'
      )
    ) {
      return true;
    }
    var countEl = document.querySelector('cart-icon [ref="cartBubbleCount"]');
    if (!countEl) return false;
    if (countEl.classList.contains('hidden')) return true;
    return parseInt(countEl.textContent, 10) === 0;
  }

  function clearExistingTowelLines() {
    return fetch(cartJsonUrl() + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart fetch failed');
        return res.json();
      })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (item) {
          if (isTowelCartItem(item) && item.key) updates[item.key] = 0;
        });
        if (!Object.keys(updates).length) return cart;
        return fetch(cartUpdateUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates }),
        }).then(function (res) {
          if (!res.ok) throw new Error('Cart update failed');
          return res.json();
        });
      });
  }

  function addItemsToCart(items, onDone) {
    if (!items.length) {
      if (onDone) onDone(false);
      return;
    }

    if (addInProgress) return;
    addInProgress = true;

    var url =
      window.Theme && Theme.routes && Theme.routes.cart_add_url
        ? Theme.routes.cart_add_url
        : '/cart/add.js';

    var payload = {
      items: items,
      sections: 'cart-drawer-section',
      sections_url: window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/',
    };

    var prepare = cartLooksEmpty() ? Promise.resolve() : clearExistingTowelLines();

    prepare
      .then(function () {
        return fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          credentials: 'same-origin',
          body: JSON.stringify(payload),
        });
      })
      .then(function (res) {
        return res.text().then(function (text) {
          var data = {};
          if (text) {
            try {
              data = JSON.parse(text);
            } catch (parseError) {
              if (!res.ok) throw new Error(text.trim() || 'Erreur panier');
              throw parseError;
            }
          }
          if (!res.ok || data.status) {
            throw new Error(data.description || data.message || text || 'Erreur panier');
          }
          return data;
        });
      })
      .then(function (data) {
        return dispatchCartUpdate(data.sections).then(function () {
          if (window.OskinaCart && typeof window.OskinaCart.notifyCount === 'function') {
            window.OskinaCart.notifyCount(data);
          }
          animateAddToCartSuccess();
          if (onDone) onDone(true);
        });
      })
      .catch(function (err) {
        console.error('[oskina-bundle]', err);
        if (onDone) onDone(false);
      })
      .finally(function () {
        addInProgress = false;
      });
  }

  function getBundleCartItems() {
    var bundle = getBundleRoot();
    if (!bundle) return null;

    var selected = getSelectedCard(bundle);
    if (!selected) return null;

    var mode = selected.getAttribute('data-bundle-mode');

    var meta = getBundleMeta(selected);

    if (mode === 'single') {
      var singleVariantId = getCardSelectedVariantId(selected);
      if (!singleVariantId) return null;
      return attachBundleProperties([{ id: singleVariantId, quantity: 1 }], meta);
    }

    if (mode === 'multi') {
      var expected = Number(selected.getAttribute('data-bundle-qty')) || 3;
      var multiItems = getMultiVariantItems(selected);
      if (multiItems.length < expected) {
        console.warn('[oskina-bundle] Sélectionnez une couleur pour chaque serviette.');
        return null;
      }
      return attachBundleProperties(mergeSameVariantItems(multiItems), meta);
    }

    return null;
  }

  function handleBundleAddToCart(event) {
    if (!getBundleRoot()) return;

    var items = getBundleCartItems();
    if (!items) return;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }

    addItemsToCart(items);
  }

  function handleBundleFormSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;
    if (!getBundleRoot()) return;

    handleBundleAddToCart(event);
  }

  function handleAddToCartButtonClick(event) {
    var button = event.target.closest(ADD_TO_CART_SELECTOR);
    if (!button || !getBundleRoot()) return;
    handleBundleAddToCart(event);
  }

  function initAddToCartOverride() {
    if (document.documentElement.getAttribute('data-oskina-bundle-cart-bound') === 'true') return;
    document.documentElement.setAttribute('data-oskina-bundle-cart-bound', 'true');

    document.addEventListener('submit', handleBundleFormSubmit, true);
    document.addEventListener('click', handleAddToCartButtonClick, true);
  }

  function initBundleSelector() {
    var bundle = getBundleRoot();
    if (!bundle) return;

    var form = getForm();
    hideQuantitySelector(form);
    toggleVariantPicker(false);

    var selected = getSelectedCard(bundle);
    if (selected) {
      selectCard(bundle, selected);
    }
  }

  function bindDelegatedEvents() {
    if (document.documentElement.getAttribute('data-oskina-bundle-delegated') === 'true') return;
    document.documentElement.setAttribute('data-oskina-bundle-delegated', 'true');

    document.addEventListener(
      'click',
      function (event) {
        var swatch = event.target.closest(SWATCH_SELECTOR);
        if (swatch) {
          handleSwatchClick(swatch, event);
          return;
        }

        var card = event.target.closest(CARD_SELECTOR);
        if (card) {
          handleCardActivate(card, event);
        }
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      var swatch = event.target.closest(SWATCH_SELECTOR);
      if (swatch && (event.key === 'Enter' || event.key === ' ')) {
        handleSwatchClick(swatch, event);
        return;
      }

      var card = event.target.closest(CARD_SELECTOR);
      if (!card) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handleCardActivate(card, event);
      }
    });
  }

  function boot() {
    initBundleSelector();
  }

  initAddToCartOverride();
  bindDelegatedEvents();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
